import _ from 'lodash'
import { INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS } from '../actions/contextoAplicacaoActions'
import { USER_LOGOUT } from '../actions/authenticationJwtActions'
import {
  DESCARTAR_VISAO_E_ITENS_POR_VISAO,
  VISAO_POR_AUDITOR_RECUPERADA
} from '../actions/itensPorVisaoActions'
import { ATUALIZAR_FILTROS } from '../actions/filtrosActions'
const INITIAL_STATE = {
  codigoUsuario: undefined,
  codigoUsuarioSelecionado: undefined,
  ready: false
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case INFORMACOES_CONTEXTO_APLICACAO_RECUPERADAS: {
      const codigoUsuario = action.payload.codigoUsuario
      return {
        ...state,
        ready: true,
        codigoUsuario,
        codigoUsuarioSelecionado: codigoUsuario
      }
    }
    case VISAO_POR_AUDITOR_RECUPERADA: {
      const codigoUsuarioSelecionado = action.payload.informacoesAuditor.codigoUsuario
      return {
        ...state,
        codigoUsuarioSelecionado,
        ready: !_.isNil(codigoUsuarioSelecionado)
      }
    }
    case DESCARTAR_VISAO_E_ITENS_POR_VISAO:
      return { ...state, codigoUsuarioSelecionado: undefined, ready: false }
    case ATUALIZAR_FILTROS:
      return { ...state, codigoUsuarioSelecionado: undefined, ready: false }
    case USER_LOGOUT:
      return INITIAL_STATE
    default:
      return state
  }
}
